import { NavigateFunction } from "react-router-dom";
import { webRoutes } from "../../../router/webRoutes";
import { WEB_SCREENS } from "../constants/screens";
import { WebStoryNavigation } from "./types";

const SCREEN_ROUTE_MAP: Record<string, string> = {
  [WEB_SCREENS.MagicBagPack]: webRoutes.magicBackpack,
  [WEB_SCREENS.FunBoxScreen]: webRoutes.doodling,
  [WEB_SCREENS.MyWall]: webRoutes.myWall,
  [WEB_SCREENS.TravelPlanScreen]: webRoutes.planner,
  [WEB_SCREENS.MyJourneyScreen]: webRoutes.journey,
  [WEB_SCREENS.Doodling]: webRoutes.doodling,
  [WEB_SCREENS.ChatBoxScreen]: webRoutes.chatbox,
  [WEB_SCREENS.KidsJournal]: webRoutes.journal,
};

const resolveRoute = (
  screen: string,
  params?: Record<string, unknown>,
): string | undefined => {
  if (screen === WEB_SCREENS.ApplicationNavigatorStack && params) {
    const nestedScreen = params.screen as string | undefined;
    if (nestedScreen) {
      return resolveRoute(nestedScreen);
    }
  }
  return SCREEN_ROUTE_MAP[screen];
};

const resolveNavigationState = (
  screen: string,
  params?: Record<string, unknown>,
): Record<string, unknown> | undefined => {
  if (screen === WEB_SCREENS.ApplicationNavigatorStack && params) {
    return params.params as Record<string, unknown> | undefined;
  }
  return params;
};

export const createWebStoryNavigation = (
  routerNavigate: NavigateFunction,
): WebStoryNavigation => ({
  navigate: (screen, params) => {
    const path = resolveRoute(screen, params);
    if (!path) return;

    const state = resolveNavigationState(screen, params);
    routerNavigate(path, state ? { state } : undefined);
  },
});
